import React, { useState, useCallback } from "react";
import PortfolioSidebar from "./components/PortfolioSidebar";
import PortfolioDetail from "./components/PortfolioDetail";
import TransferModal from "./components/TransferModal";
import { usePortfolio } from "./hooks/usePortfolio";
import { MasterDetailLayout, Breadcrumb } from "../../../components/Common";

/**
 * PortfolioPage (Carteira de Clientes)
 * Layout Master-Detail: sidebar com employees, detail com clientes do employee selecionado.
 */
const PortfolioPage = () => {
    const {
        employees,
        members,
        selectedMemberIds,
        loading,
        loadingMembers,
        isTransferring,
        transferModalOpen,
        setTransferModalOpen,
        searchTerm,
        setSearchTerm,
        statusFilter,
        setStatusFilter,
        filteredMembers,
        actions
    } = usePortfolio();

    const [selectedEmployee, setSelectedEmployee] = useState(null);

    // Ao selecionar um employee na sidebar
    const handleSelectEmployee = useCallback((employee) => {
        if (selectedEmployee?.id === employee.id) return;
        setSelectedEmployee(employee);
        actions.fetchMembers(employee.id);
    }, [selectedEmployee, actions]);

    return (
        <React.Fragment>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb title="Carteira de Clientes" />
            </div>

            <div className="border-top mb-3"></div>

            <div className="portfolio-container mt-3">
                <MasterDetailLayout
                master={
                    <PortfolioSidebar
                        employees={employees}
                        activeId={selectedEmployee?.id}
                        onSelect={handleSelectEmployee}
                        loading={loading}
                    />
                }
                detail={
                    <PortfolioDetail
                        employee={selectedEmployee}
                        members={members}
                        selectedMemberIds={selectedMemberIds}
                        onToggleMember={actions.toggleMemberSelection}
                        onToggleSelectAll={actions.toggleSelectAll}
                        onTransferClick={() => setTransferModalOpen(true)}
                        loadingMembers={loadingMembers}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        statusFilter={statusFilter}
                        setStatusFilter={setStatusFilter}
                        filteredMembers={filteredMembers}
                    />
                }
            />
            </div>

            {/* Modal de Transferência */}
            <TransferModal
                isOpen={transferModalOpen}
                toggle={() => setTransferModalOpen(false)}
                employees={employees}
                currentEmployeeId={selectedEmployee?.id}
                selectedCount={selectedMemberIds.length}
                onConfirm={(targetId) => actions.transferMembers(targetId, selectedEmployee?.id)}
                isTransferring={isTransferring}
            />
        </React.Fragment>
    );
};

export default PortfolioPage;
